import { deckIds } from "./ids"
import type { Deck } from "."

export const isValidCard = (subject: Deck.Card | any): subject is Deck.Card => {
  const card = subject as Deck.Card

  return deckIds.includes(card.deck) && typeof card.key == "string"
}
